import styled from 'styled-components';

export const EmptyStateWrapper = styled.div`
    #empty-state {
        padding-top: 42px;
        padding-bottom: 42px;
    }
`;

export const LandingPagePublishUnavailableMessage = styled.div`
    text-align: center;
    line-height: 20px;
`;
